const initFaqs = () => {
  document.querySelectorAll('[data-faq-section]').forEach((section) => {
    const questionsPanel = section.querySelector('[data-faq-questions]');
    const answerPanel = section.querySelector('[data-faq-answer]');
    const answerQuestion = section.querySelector('[data-faq-answer-question]');
    const answerContent = section.querySelector('[data-faq-answer-content]');
    const searchInput = section.querySelector('[data-faq-search]');
    const noResults = section.querySelector('[data-faq-no-results]');
    const groups = section.querySelectorAll('[data-faq-group]');

    if (!questionsPanel || !answerPanel || !searchInput) return;

    section.querySelectorAll('[data-faq-item]').forEach((item) => {
      item.addEventListener('click', () => {
        const tpl = item.nextElementSibling;
        answerQuestion.textContent = item.dataset.question;
        answerContent.innerHTML = tpl ? tpl.innerHTML : '';
        questionsPanel.style.transform = 'translateX(-100%)';
        answerPanel.style.transform = 'translateX(0)';
        answerPanel.scrollTop = 0;
      });
    });

    section.querySelector('[data-faq-back]')?.addEventListener('click', () => {
      answerPanel.style.transform = 'translateX(100%)';
      questionsPanel.style.transform = '';
    });

    searchInput.addEventListener('input', () => {
      const term = searchInput.value.trim().toLowerCase();
      let anyVisible = false;

      groups.forEach((group) => {
        let groupVisible = false;
        group.querySelectorAll('[data-faq-item]').forEach((item) => {
          const tpl = item.nextElementSibling;
          const answerText = tpl ? tpl.innerHTML.replace(/<[^>]+>/g, ' ').toLowerCase() : '';
          const matches = !term || item.dataset.search.includes(term) || answerText.includes(term);
          item.style.display = matches ? '' : 'none';
          if (tpl) tpl.style.display = matches ? '' : 'none';
          if (matches) { groupVisible = true; anyVisible = true; }
        });
        group.style.display = groupVisible ? '' : 'none';
      });

      noResults?.classList.toggle('hidden', !term || anyVisible);
    });
  });
};

export default initFaqs;
